import CalendarClock from "./SVG/calendarClock.svg?react";

const CalendarClockIcon = () => {
  return <CalendarClock />;
};

export default CalendarClockIcon;
